import { storage } from '@/lib/firebase';
import { ref, uploadString, getDownloadURL } from 'firebase/storage';

export interface UploadedDocRef {
  name: string;
  mimeType: string;
  url: string;
  path: string;
}

/**
 * Uploads analyzed financial/corporate documents to Firebase Storage
 * under a temporary session folder. These get linked to the real
 * dealId once the deal is created (post-payment in PaymentSuccess.tsx).
 */
export async function uploadAnalyzedDocuments(
  sessionId: string,
  files: { name: string; base64: string; mimeType: string }[]
): Promise<UploadedDocRef[]> {
  const results: UploadedDocRef[] = [];
  for (const file of files) {
    const safeName = file.name.replace(/[^a-zA-Z0-9._-]/g, '_');
    const path = `dealDraftDocuments/${sessionId}/${Date.now()}_${safeName}`;
    const storageRef = ref(storage, path);
    await uploadString(storageRef, file.base64, 'base64', { contentType: file.mimeType });
    const url = await getDownloadURL(storageRef);
    results.push({ name: file.name, mimeType: file.mimeType, url, path });
  }
  return results;
}

/**
 * Generates or retrieves a stable session ID for the current
 * deal submission draft, used to group uploaded documents
 * before the deal officially exists in Firestore.
 */
export function getOrCreateDraftSessionId(): string {
  const KEY = 'dealDraftSessionId';
  let id = sessionStorage.getItem(KEY);
  if (!id) {
    id = `draft_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
    sessionStorage.setItem(KEY, id);
  }
  return id;
}